import { IRegisterInterestDataBuilder } from "./IRegisterInterestDataBuilder";
import { TRegisterInterestRequest } from "./TRegisterInterestRequest";

/**
 * Data builder for Social Studies landing pages.
 *
 * Extends the default data with locale and optional module code.
 * Module code is present when registering from a year-specific module page,
 * and absent when registering from the main Social Studies landing page.
 */
export default class SocialStudiesDataBuilder
  implements IRegisterInterestDataBuilder
{
  /**
   * @param moduleCode The module code base (e.g. 'universsocialY3'), or null from main landing page
   * @param locale The locale ('en-CA' or 'fr-CA')
   */
  constructor(
    private readonly moduleCode: string | null,
    private readonly locale: string,
  ) {}

  public BuildRequestData(
    email: string,
    product: string,
    interest: string,
    origin: string | null,
  ): TRegisterInterestRequest {
    const interestSchool = product === "school";
    const interestFamily = product === "family";

    const data: TRegisterInterestRequest = {
      email: email,
      interest: interest,
      interestSchool: interestSchool,
      interestFamily: interestFamily,
      locale: this.locale,
    };

    if (this.moduleCode) {
      data.moduleCode = this.moduleCode;
    }

    if (origin) {
      data.origin = origin;
    }

    return data;
  }
}
